module.exports = __webpack_public_path__ + "img/multiplier_normal_1.5171bc24.png";